// extracted by mini-css-extract-plugin
export var contentBody = "_8u-9";
export var headerImage = "_8u-2";
export var imageButton = "_8u-7";
export var imageButtonIcon = "_8u-8";
export var imageHeader = "_8u-4";
export var imageHeaderText = "_8u-5";
export var imageOverlay = "_8u-3";
export var imageTitle = "_8u-6";
export var imageWrapper = "_8u-1";
export var taskList = "_8u-a";
export var widget = "_8u-0";